import { Directive, input, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { skip } from 'rxjs';

import { CandidateAnalytics } from '@core/candidate-util';
import { CollapsibleCardComponent } from '@core/user-interface-legacy';

@Directive({
  selector: '[rtCollapsibleCardAnalytics]',
  standalone: true,
})
export class CollapsibleCardAnalyticsDirective {
  private readonly candidateAnalytics = inject(CandidateAnalytics, { optional: true });
  private readonly collapsibleCard = inject(CollapsibleCardComponent);

  public rtCollapsibleCardAnalyticsKey = input.required<string | undefined>({
    alias: 'analyticsKey',
  });

  constructor() {
    toObservable(this.collapsibleCard.isCollapsed)
      .pipe(skip(1), takeUntilDestroyed())
      .subscribe(() => {
        if (this.rtCollapsibleCardAnalyticsKey()?.length && this.candidateAnalytics) {
          this.candidateAnalytics.trackProfileSectionToggle(
            this.rtCollapsibleCardAnalyticsKey()!,
            this.collapsibleCard.isCollapsed() ? 'collapse' : 'expand',
          );
        }
      });
  }
}
